export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Products", to: "/products" },
  { label: "Capabilities", to: "/capabilities" },
  { label: "Industries", to: "/industries" },
  { label: "Contact", to: "/contact" },
];

export const CAPABILITIES = [
  {
    id: "cnc-machining",
    name: "CNC Machining",
    icon: "Cpu",
    img: "/images/cnc-machining.jpg",
    alt: "CNC machining centre cutting a metal component",
    desc: "Precision CNC machining of components to customer drawings, with consistent accuracy across production runs.",
  },
  {
    id: "turning",
    name: "Turning",
    icon: "RotateCw",
    img: "/images/turning.jpg",
    alt: "Lathe turning a cylindrical metal component",
    desc: "Turning of shafts, rollers, bushes and cylindrical components to required dimensions and finishes.",
  },
  {
    id: "milling",
    name: "Milling",
    icon: "Layers",
    img: "/images/milling.jpg",
    alt: "Milling machine machining a metal workpiece",
    desc: "Milling of plates, blocks, die components and prismatic parts for tooling and industrial applications.",
  },
  {
    id: "grinding",
    name: "Grinding",
    icon: "Disc",
    img: "/images/grinding.jpg",
    alt: "Precision grinding of a metal component",
    desc: "Grinding of components to drawing dimensions and surface-finish requirements.",
  },
  {
    id: "surface-grinding",
    name: "Surface Grinding",
    icon: "RectangleHorizontal",
    img: "/images/surface-grinding.jpg",
    alt: "Surface grinding of a flat precision plate",
    desc: "Surface grinding of die plates, mould bases and flat precision components.",
  },
  {
    id: "tool-die",
    name: "Tool & Die Manufacturing",
    icon: "Wrench",
    img: "/images/tool-die.jpg",
    alt: "Tool and die components on a workbench",
    desc: "Manufacture of press tools, gasket Dies, mould bases and production tooling built to customer requirements.",
  },
  {
    id: "custom-components",
    name: "Custom Component Manufacturing",
    icon: "DraftingCompass",
    img: "/images/custom-components.jpg",
    alt: "Custom machined metal components",
    desc: "Custom industrial components manufactured from customer drawings and technical specifications.",
  },
];

export const PRODUCT_CATEGORIES = [
  "All",
  "Tooling & Dies",
  "Machined Components",
  "Custom Components",
];

export const PRODUCTS = [
  {
    id: "die-plates",
    name: "Die Plates",
    category: "Tooling & Dies",
    img: "/images/die-plates.jpg",
    alt: "Precision-machined die plates manufactured by Radiant Machine Tools",
    desc: "Machined die plates and backing plates for tooling assemblies.",
  },
  {
    id: "jigs-fixtures",
    name: "Jigs & Fixtures",
    category: "Tooling & Dies",
    img: "/images/jigs-fixtures.jpg",
    alt: "Jigs and fixtures manufactured by Radiant Machine Tools",
    desc: "Custom jigs and fixtures manufactured to customer drawings and production requirements.",
  },
  {
    id: "shafts-rollers",
    name: "Shafts & Rollers",
    category: "Custom Components",
    img: "/images/shafts-rollers.jpg",
    alt: "Precision machined shafts and rollers",
    desc: "Precision shafts and rollers turned and ground to drawing dimensions.",
  },
  {
    id: "conveyor-rollers",
    name: "Conveyor Rollers",
    category: "Custom Components",
    img: "/images/conveyor-rollers.jpg",
    alt: "Roller conveyor assembly with chain-driven rollers manufactured by Radiant Machine Tools",
    desc: "Conveyor rollers manufactured to required sizes for material-handling systems.",
  },
  {
    id: "pulleys-rings",
    name: "Pulleys & Rings",
    category: "Custom Components",
    img: "/images/pulleys-rings.jpg",
    alt: "Machined pulleys and metal rings",
    desc: "Pulleys, rings and round machined components to customer specifications.",
  },
  {
    id: "spm-equipment",
    name: "Special Purpose Machines & Equipment",
    category: "Machined Components",
    img: "/images/work-band-inserter.jpg",
    alt: "Special purpose machine custom-built by Radiant Machine Tools",
    desc: "Special purpose machines and equipment custom-built to suit specific production requirements.",
  },
  {
    id: "assemblies-subassemblies",
    name: "Assemblies & Sub-Assemblies",
    category: "Machined Components",
    img: "/images/assemblies-subassemblies.jpg",
    alt: "Assemblies and sub-assemblies manufactured by Radiant Machine Tools",
    desc: "Assemblies and sub-assemblies manufactured and put together to customer specifications.",
  },
  {
    id: "custom-components",
    name: "Customer-Specific Components",
    category: "Machined Components",
    img: "/images/custom-components.jpg",
    alt: "Customer-specific precision components manufactured by Radiant Machine Tools",
    desc: "Drawing-based precision components manufactured to your materials and technical specifications.",
  },
];

export const INDUSTRIES = [
  {
    id: "industrial-manufacturing",
    name: "Industrial Manufacturing",
    img: "/images/industries-manufacturing.jpg",
    alt: "Industrial manufacturing facility",
    desc: "Tooling, Dies and machined components used across general manufacturing operations.",
  },
  {
    id: "engineering",
    name: "Engineering",
    img: "/images/industries-engineering.jpg",
    alt: "Engineering work on industrial equipment",
    desc: "Precision-machined parts for engineering assemblies, fixtures and equipment.",
  },
  {
    id: "tooling",
    name: "Tooling",
    img: "/images/tool-die.jpg",
    alt: "Tool room Dies and tooling components",
    desc: "Dies, press tools and mould bases for tool rooms and production tooling.",
  },
  {
    id: "machinery",
    name: "Machinery",
    img: "/images/industries-machinery.jpg",
    alt: "Industrial machinery and equipment",
    desc: "Shafts, rollers and machined components for industrial machinery.",
  },
  {
    id: "automotive-components",
    name: "Automotive Components",
    img: "/images/industries-automotive.jpg",
    alt: "Automotive component manufacturing line",
    desc: "Machined parts and tooling used in automotive component manufacturing.",
  },
  {
    id: "general-industrial",
    name: "General Industrial Applications",
    img: "/images/industries-general.jpg",
    alt: "General industrial plant environment",
    desc: "Custom components manufactured to drawing for diverse industrial uses.",
  },
];

export const PROCESS_STEPS = [
  { no: "01", title: "Requirement", desc: "You share your component or tooling requirement with our team." },
  { no: "02", title: "Drawing / Technical Specification", desc: "We review your drawing, dimensions, tolerances and material requirements." },
  { no: "03", title: "Manufacturing", desc: "Components are machined and built to the agreed specification." },
  { no: "04", title: "Quality Check", desc: "Parts are checked against drawing dimensions and finish requirements." },
  { no: "05", title: "Delivery", desc: "Finished components are packed and dispatched to your schedule." },
];

export const SELECTED_WORK_SLOTS = [
  {
    id: "band-inserter",
    name: "Band Inserter Machine",
    img: "/images/work-band-inserter.jpg",
    alt: "Custom-built band inserter machine with roller-based setup manufactured by Radiant Machine Tools",
    process: "Roller-Based Setup • Adjustable Components",
    desc: "A custom-built machine developed for band insertion and material handling, with a roller-based setup and adjustable components to keep the material moving and positioned properly during operation.",
  },
  {
    id: "sidewall-recutter",
    name: "Side Wall Re-Cutter Machine",
    img: "/images/work-sidewall-recutter.jpg",
    alt: "Custom-built side wall re-cutter machine with roller conveyor and cutting arrangement",
    process: "Roller Conveyor • Cutting Arrangement",
    desc: "A custom-built machine made for re-cutting tyre side wall material, with a roller conveyor and cutting arrangement to handle the material smoothly during the process.",
  },
  {
    id: "rubber-slitter",
    name: "Rubber Stock Slitter Machine",
    img: "/images/work-rubber-slitter.jpg",
    alt: "Rubber stock slitter machine with multiple rollers and guided cutting setup",
    process: "Multi-Roller • Guided Cutting",
    desc: "A rubber slitting machine built for cutting rubber stock into the required widths, using multiple rollers and a guided setup to keep the material aligned while cutting.",
  },
  {
    id: "tyre-building",
    name: "Tyre Building Machine",
    img: "/images/work-tyre-building.jpg",
    alt: "Custom-built tyre building machine with pneumatic arrangements fabricated and assembled by Radiant Machine Tools",
    process: "Roller Conveyor • Pneumatic • Fabricated Assembly",
    desc: "A custom-built tyre building machine with a roller conveyor and pneumatic arrangements for handling and positioning the material, fabricated and assembled to suit the required production setup.",
  },
];

export const CLIENT_LOGOS = [
  { id: "apollo-tyres", name: "Apollo Tyres" },
  { id: "mahindra", name: "Mahindra" },
  { id: "bharat-dynamics", name: "Bharat Dynamics Limited" },
  { id: "schneider-electric", name: "Schneider Electric" },
  { id: "sgd-pharma", name: "SGD Pharma" },
  { id: "itc-limited", name: "ITC Limited" },
  { id: "mrf", name: "MRF" },
  { id: "bhel", name: "BHEL" },
];

export const REQUIREMENT_OPTIONS = [
  ...CAPABILITIES.map((c) => c.name),
  "Product Enquiry",
  "General Enquiry",
  "Other",
];
